module.exports = __webpack_public_path__ + "img/floating-button-1.420fc079.svg";